import React, { useState } from "react";
import {
    Box,
    Typography,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    Select,
    MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import CustomDataGrid from "../../Components/CustomDataGrid"; // Adjust the import path as needed

const StockList = () => {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [item, setItem] = useState({
        name: "",
        barcode: "",
        description: "",
        typeId: 0,
        priceNormal: 0,
        priceWholesale: 0,
    });

    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [isAddStockDialogOpen, setIsAddStockDialogOpen] = useState(false);

    const handleOpenDialog = (id) => {
        setSelectedRowId(id);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmDelete = () => {
        setRows(rows.filter((row) => row.id !== selectedRowId));
        setOpenDialog(false);
    };

    const columns = [
        {
            field: "id",
            headerName: "Id",
            description: "id in the db",
            minWidth: 50,
            flex: 1,
        },
        {
            field: "ItemId",
            headerName: "Item Id",
            editable: true,
            minWidth: 50,
            flex: 1,
        },
        {
            field: "Name",
            headerName: "Name",
            editable: true,
            minWidth: 50,
            flex: 1,
        },
        {
            field: "ProducedBy",
            headerName: "Produced By",
            editable: true,
            minWidth: 50,
            flex: 1,
        },
        {
            field: "ProductionDate",
            headerName: "Production Date",
            type: "date",
            editable: true,
            minWidth: 50,
            flex: 1,
        },
        {
            field: "ExpiryDate",
            headerName: "Expiry Date",
            type: "date",
            editable: true,
            minWidth: 50,
            flex: 1,
        },
        {
            field: "PurchaseDate",
            headerName: "Purchase Date",
            type: "date",
            editable: true,
            minWidth: 50,
            flex: 1,
        },
    ];

    const actions = [
        {
            title: "Add",
            color: "primary",
            handler: () => navigate("AddStockItem"),
            parameters: ["id"],
            icon: <AddIcon />,
        },
        {
            title: "Delete",
            color: "error",
            handler: handleOpenDialog,
            parameters: ["id"],
            icon: <DeleteIcon />,
        },
    ];

    const handleSubmit = () => {
        console.log(item);
    };
    return (
        <Box sx={{ width: "100%" }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                }}
            >
                <Typography
                    variant="h4"
                    sx={{ fontWeight: "bold" }}
                    color="primary"
                    gutterBottom
                >
                    Stock List
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setIsAddStockDialogOpen(true)}
                >
                    Add Stock
                </Button>
            </Box>
            <CustomDataGrid
                columns={columns}
                rows={rows}
                actions={actions}
                perPage={20}
            />
            <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this row?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirmDelete}
                        variant="contained"
                        color="error"
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={isAddStockDialogOpen}
                onClose={() => {
                    setIsAddStockDialogOpen(false);
                }}
            >
                <DialogTitle>Add Stock</DialogTitle>
                <DialogContent>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            direction: "ltr",
                            py: "10px",
                        }}
                    >
                        <TextField
                            value={item.name}
                            onChange={(e) =>
                                setItem((prevItem) => ({
                                    ...prevItem,
                                    name: e.target.value,
                                }))
                            }
                            label="Name"
                            size="small"
                        />

                        <TextField
                            value={item.barcode}
                            onChange={(e) =>
                                setItem((prevItem) => ({
                                    ...prevItem,
                                    barcode: e.target.value,
                                }))
                            }
                            label="Barcode"
                            size="small"
                        />
                        <TextField
                            value={item.description}
                            multiline
                            rows={4}
                            onChange={(e) =>
                                setItem((prevItem) => ({
                                    ...prevItem,
                                    description: e.target.value,
                                }))
                            }
                            label="Description"
                            size="small"
                        />
                        <Select
                            onChange={(e) =>
                                setItem({ ...item, typeId: e.target.value })
                            }
                            value={item.typeId}
                            label="Type"
                            size="small"
                        >
                            <MenuItem value={2}>Normal</MenuItem>
                            <MenuItem value={1}>Hidden</MenuItem>
                        </Select>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="error"
                        onClick={() => {
                            setIsAddStockDialogOpen(false);
                        }}
                    >
                        Cancel
                    </Button>
                    <Button variant="contained" onClick={handleSubmit}>
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default StockList;
